module.exports = __webpack_public_path__ + "img/104.e6e392d1.png";